export const HOMEOWNER_CORE_PLAN_ID = 75;
export const HOMEOWNER_CORE_PLUS_PLAN_ID = 76;
export const HOMEOWNER_ULTIMATE_PLAN_ID = 77;
export const GAS_BOILER_SERVICE_JOB_TYPE_CODE = "HSGAS";
export const CARE_PLAN_COMBO_DISCOUNT_ID = 95;
export const CARE_PLAN_DISCOUNT_ID = 12;
export const CARE_PLAN_DISCOUNT_PERCENTAGE = 10.0;

// Predefined valid care plans and job types
export const VALID_CARE_PLANS = [
  HOMEOWNER_CORE_PLAN_ID,
  HOMEOWNER_CORE_PLUS_PLAN_ID,
  HOMEOWNER_ULTIMATE_PLAN_ID,
]; // Example care plan IDs
export const VALID_JOB_TYPES = [GAS_BOILER_SERVICE_JOB_TYPE_CODE]; // Example job type codes
export const VALID_CARE_PLANS_DISCOUNTS = [
  CARE_PLAN_COMBO_DISCOUNT_ID,
  CARE_PLAN_DISCOUNT_ID,
]; // Example care plan discount IDs

export const SERVICE_PLUS_TYPE_ID = 25;
export const INSTALL_PLUS_TYPE_ID = 56;
export const NEW_AGREEMENTS_TYPE_ID_START = 74;
export const NEW_AGREEMENTS_TYPE_ID_END = 81;

export const SERVICE_INSTALL_PLUS_TYPE_IDS = [
  SERVICE_PLUS_TYPE_ID,
  INSTALL_PLUS_TYPE_ID,
];

// Failed Reason IDs
export const FAILED_REASON_CALLING_ROUND = 1;
export const FAILED_REASON_CUSTOMER_NEEDS_AUTHORISATION = 3;
export const FAILED_REASON_HUNG_UP = 4;
export const FAILED_REASON_NO_MEANS_TO_PAY = 6;
export const FAILED_REASON_ONLY_ADVICE_REQUIRED = 9;
export const FAILED_REASON_PRICE_ONLY_REQUIRED = 11;
export const FAILED_REASON_TOO_EXPENSIVE = 13;
export const FAILED_REASON_DOUBLE_BOOKING = 15;
export const FAILED_REASON_NO_COVERAGE = 102;
export const FAILED_REASON_LOOKING_FOR_SMALL_INDEPENDENT = 103;
export const FAILED_REASON_WANTED_TO_PAY_BY_CASH = 104;
export const FAILED_REASON_FAILED_NO_COVERAGE = 110;
export const FAILED_REASON_SAME_DAY_ATTENDANCE_SUNDAY = 99; // New reason for Sunday same-day requests

// Valid Failed Reason IDs for Stage 3 Booking Rejection
export const VALID_STAGE3_FAILED_REASON_IDS = [
  FAILED_REASON_CALLING_ROUND,
  FAILED_REASON_CUSTOMER_NEEDS_AUTHORISATION,
  FAILED_REASON_HUNG_UP,
  FAILED_REASON_NO_MEANS_TO_PAY,
  FAILED_REASON_ONLY_ADVICE_REQUIRED,
  FAILED_REASON_PRICE_ONLY_REQUIRED,
  FAILED_REASON_TOO_EXPENSIVE,
  FAILED_REASON_DOUBLE_BOOKING,
  FAILED_REASON_NO_COVERAGE,
  FAILED_REASON_LOOKING_FOR_SMALL_INDEPENDENT,
  FAILED_REASON_WANTED_TO_PAY_BY_CASH,
  FAILED_REASON_FAILED_NO_COVERAGE,
  FAILED_REASON_SAME_DAY_ATTENDANCE_SUNDAY,
];
